import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import fetchPlaidItems from './useHurdlrPlaidItems.request';
import { HurdlrPlaidItemsData, HurdlrPlaidItemsParams } from './useHurdlrPlaidItems.interface';

export const createUseHurdlrPlaidItemsKey = (params?: HurdlrPlaidItemsParams): QueryKey => {
    return ['hurdlr', 'useHurdlrPlaidItems', params];
};

const useHurdlrPlaidItems = <T = HurdlrPlaidItemsData>(
    params?: HurdlrPlaidItemsParams,
    options?: UseQueryOptions<HurdlrPlaidItemsData, AxiosError, T>
) => {
    // ✅ FIX: Disable query when memberId is undefined to prevent flickering
    const isQueryEnabled = params?.memberId !== undefined;

    const query = useQuery({
        queryKey: createUseHurdlrPlaidItemsKey(params),
        queryFn: () => fetchPlaidItems(params),
        enabled: isQueryEnabled, // ✅ Only run query when memberId is available
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 0, // ✅ Allow immediate refetching after Plaid success
        ...options,
    });

    return query;
};

export default useHurdlrPlaidItems;
